export enum SourceTypeEnum {
  comparable= 'comparable',
  property = 'property',
  contact = 'contact',
  occupier = 'occupier',
  deal = 'deal',
  company = 'company',
  availability = 'availability',
  pipeline = 'pipeline',
  pipelinesDashboard = 'pipelines-dashboard',
  dealsDashboard = 'deals-dashboard',
  availabilitiesDashboard = 'availabilities-dashboard',
  comparablesDashboard = 'comparables-dashboard',
}

export * from './ListsDashboardSourceEnum';
export * from './LayoutEnum';
export * from './SourceClassEnum';
